import React, { useState, useRef, useEffect } from "react";
import editIcon from "../../../assets/images/editIcon02.png";
import saveIcon from "../../../assets/images/Check.svg";
import clearIcon from "../../../assets/images/X.svg";
import { capitalizeFirstLetter } from "../../../constants/events";

const SelectField = ({
  options,
  optionList,
  name,
  id,
  onChangeOption,
  defaultValue,
  customStyle = "",
  isReadOnly = false,
  showEditIcon = false,
  saveEdit,
  required,
  defaultCustomStyle,
  editCustomStyle,
  dataId = "",
  optionCustomStyle = "",
  label,
  onFieldBlur,
  onEditClick,
  onCancelEdit,
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [updatedVal, setUpdatedVal] = useState('');
  const selectRef = useRef(null);

  const isOptionUpdate = true;
  let notEditable = false;
  if (isReadOnly && !showEditIcon) notEditable = true;

  useEffect(() => {
    if (isEditable && selectRef.current) {
      selectRef.current.focus();
    }
  }, [isEditable]);

  const onOptionSelect = (e) => {
    if (showEditIcon) {
      setUpdatedVal(e.target.value);
    }
    onSelect(e)
  }
  const onSelect = (e) => {
    onChangeOption(id, e.target.value, isOptionUpdate)
  }
  const onSaveEdit = () => {
    if (defaultValue === updatedVal) {
      setIsEditable(false);
    } else {
      const isValueEdited = Boolean(defaultValue);
      saveEdit(id, updatedVal, isValueEdited, name, isOptionUpdate, optionList);
      setIsEditable(false);
    }
  };

  const onBlur = (e) => {
    if (onFieldBlur && isEditable) {
      const next = e.relatedTarget;
      const isSaveOrCancel =
        next?.alt === "save edit" ||
        next?.alt === "clear edit" ||
        next?.closest(".save-cancel-wrapper");

      if (!e.currentTarget.contains(next) && !isSaveOrCancel) {
        onFieldBlur();
      }
    };
  };

  const handleCancel = async () => {
    setUpdatedVal('');
    setIsEditable(false);
    if (onCancelEdit) await onCancelEdit();
  };

  return (
    <div className={`flex ${showEditIcon ? "justify-between" : "justify-start"}`}>
      {showEditIcon && !isEditable && defaultValue && (
        <p
          className={`text-sm text-left text-tileGray font-normal capitalize ${
            defaultCustomStyle ? "mt-0" : "mt-1"
          }`}
        >
          {defaultValue}
        </p>
      )}

      {(!showEditIcon || (showEditIcon && isEditable) || !defaultValue) && (
        <select
          ref={selectRef}
          className={`w-3/5 border-none outline-none text-sm text-left text-[#c9a7a7] placeholder-grayNobel disabled:text-[#000] focus:text-tileGray font-normal h-5 ${
            defaultCustomStyle ? "mt-0" : "mt-1"
          } ${customStyle} appearance-none`}
          name={name}
          id={id}
          defaultValue={defaultValue}
          required={required}
          disabled={notEditable || (showEditIcon && !isEditable)}
          onChange={(e) => onOptionSelect(e)}
          onBlur={(e) => onBlur(e)}
          data-id={dataId}
        >
          {options.map((option, index) => (
            <option
              className={optionCustomStyle}
              key={option}
              value={index === 0 ? "" : option}
              selected={defaultValue === option}
            >
              {capitalizeFirstLetter(option)}
            </option>
          ))}
        </select>
      )}

      {showEditIcon && !isEditable && (
        <button
          type="button"
          aria-label="edit"
          data-action="edit"
          className={`ml-ten -mt-4 ${editCustomStyle}`}
          onClick={() => {
            setIsEditable(true);
            if (onEditClick) onEditClick(label, true);
          }}
        >
          <img src={editIcon} alt="edit" className="h-4 w-4 cursor-pointer" />
        </button>
      )}

      {isEditable && (
        <div className="save-cancel-wrapper grid -mt-4 ml-2 gap-2">
          <button
            type="button"
            data-action="save"
            aria-label="save edit"
            className="w-4 h-4 cursor-pointer flex items-center justify-center"
            onClick={onSaveEdit}
          >
            <img src={saveIcon} alt="save" className="w-4 h-4" />
          </button>

          <button
            type="button"
            data-action="cancel"
            aria-label="cancel edit"
            className="w-4 h-4 cursor-pointer flex items-center justify-center"
            onClick={handleCancel}
          >
            <img src={clearIcon} alt="cancel" className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
};

export default SelectField;
